<div class="close-icon" mat-button (click)="dialogRef.close()"></div>

<mat-dialog-content style="margin-top: 40px;">
  <div class="splitter">Workstream Item</div>
  <div style="display: flex; flex-direction: row;">
    <div style="flex:32%">
      <mat-form-field style="width: 100%">
        <mat-label>Name</mat-label>
        <input matInput
               [(ngModel)]="workstreamItem.wsid"
               required>
      </mat-form-field>
    </div>
    <div style="flex:1%"></div>
    <div style="flex:20%">
      <mat-form-field style="width: 100%">
        <mat-label>Owner</mat-label>
        <mat-select name="ownerId"
                    [(ngModel)]="workstreamItem.ownerId">
          <mat-option></mat-option>
          <mat-option *ngFor="let user of users" [value]="user.userId">
            {{user.firstName}} {{user.lastName}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div style="flex:1%"></div>
    <div style="flex:15%" *ngIf="!isMaster()">
      <mat-form-field style="width: 100%">
        <mat-label>Status</mat-label>
        <mat-select name="ownerId"
                    [(ngModel)]="workstreamItem.status">
          <mat-option value=""></mat-option>
          <mat-option value="Not Started">Not Started</mat-option>
          <mat-option value="In-Progress">In-Progress</mat-option>
          <mat-option value="Dev Complete">Dev Complete</mat-option>
          <mat-option value="Deployed">Deployed</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div style="flex:1%"></div>
    <div style="flex:20%">
      <mat-form-field style="width: 100%">
        <mat-label>Topic</mat-label>
        <mat-select name="ownerId"
                    [(ngModel)]="workstreamItem.type" required>
          @for(topic of topics; track topic.name) {
            <mat-option [value]="topic.name">{{topic.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div style="flex:1%"></div>
    <div style="flex:32%">
      <mat-form-field style="width: calc(100% - 40px)">
        <mat-label>Due</mat-label>
        <input matInput
               name="dueDate"
               [(ngModel)]="workstreamItem.dueDate"
               [matDatepicker]="picker">
      </mat-form-field>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </div>
  </div>
  <div style="display: flex; flex-direction: row;">
    <div style="flex:100%">
      <mat-form-field style="width: 100%">
        <mat-label>Key Resources</mat-label>
        <input matInput
               [(ngModel)]="workstreamItem.keyResources">
      </mat-form-field>
    </div>
  </div>
  <mat-accordion [multi]="true">
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Overview</mat-panel-title>
      </mat-expansion-panel-header>
      <div style="display: flex; flex-direction: row;">
        <div style="flex:0 0 100%">
          <mat-label style="color: rgba(0,0,0,.54)">Description</mat-label>
          <div [innerHTML]="workstreamItem.description"></div>
        </div>
      </div>
      <div style="display: flex; flex-direction: row;">
        <div style="flex:0 0 100%">
          <mat-label style="color: rgba(0,0,0,.54)">Guidance</mat-label>
          <div [innerHTML]="workstreamItem.guidance"></div>
        </div>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Implementation Guidance</mat-panel-title>
      </mat-expansion-panel-header>
      <div style="display: flex; flex-direction: row;">
        <div style="flex:0 0 100%">
          <mat-label style="color: rgba(0,0,0,.54)">Implementation Details</mat-label>
          <div [innerHTML]="workstreamItem.implementationDetails"></div>
        </div>
      </div>
      <div style="display: flex; flex-direction: row;">
        <div style="flex:0 0 100%">
          <mat-label style="color: rgba(0,0,0,.54)">Config Info</mat-label>
          <div [innerHTML]="workstreamItem.configInfo"></div>
        </div>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel expanded>
      <mat-expansion-panel-header>
        <mat-panel-title>Customer Responsibilities</mat-panel-title>
      </mat-expansion-panel-header>
      <div style="display: flex; flex-direction: row;">
        <div style="flex:0 0 100%">
          <mat-label style="color: rgba(0,0,0,.54)">Responsibility Details</mat-label>
          <p-editor matInput
                    type="text"
                    name="references"
                    [(ngModel)]="workstreamItem.details">
            <p-header>
              <span class="ql-formats">
                <select class="ql-size">
                  <option value="huge">Heading</option>
                  <option value="large">Subheading</option>
                  <option selected></option>
                  <option value="small">Small</option>
                </select>
                <select class="ql-font">
                  <option selected="">Sans Serif</option>
                  <option value="serif">Serif</option>
                  <option value="monospace">
                    Monospace
                  </option>
                </select>
              </span>
              <span class="ql-formats">
                <button class="ql-bold" aria-label="Bold"></button>
                <button class="ql-italic" aria-label="Italic"></button>
                <button class="ql-underline" aria-label="Underline"></button>
                <button class="ql-strike" aria-label="Strike"></button>
              </span>
              <span class="ql-formats">
                <select class="ql-color">
                  <option selected="selected"></option>
                  <option value="#e60000"></option>
                  <option value="#ff9900"></option>
                  <option value="#ffff00"></option>
                  <option value="#008a00"></option>
                  <option value="#0066cc"></option>
                  <option value="#9933ff"></option>
                  <option value="#ffffff"></option>
                  <option value="#facccc"></option>
                  <option value="#ffebcc"></option>
                  <option value="#ffffcc"></option>
                  <option value="#cce8cc"></option>
                  <option value="#cce0f5"></option>
                  <option value="#ebd6ff"></option>
                  <option value="#bbbbbb"></option>
                  <option value="#f06666"></option>
                  <option value="#ffc266"></option>
                  <option value="#ffff66"></option>
                  <option value="#66b966"></option>
                  <option value="#66a3e0"></option>
                  <option value="#c285ff"></option>
                  <option value="#888888"></option>
                  <option value="#a10000"></option>
                  <option value="#b26b00"></option>
                  <option value="#b2b200"></option>
                  <option value="#006100"></option>
                  <option value="#0047b2"></option>
                  <option value="#6b24b2"></option>
                  <option value="#444444"></option>
                  <option value="#5c0000"></option>
                  <option value="#663d00"></option>
                  <option value="#666600"></option>
                  <option value="#003700"></option>
                  <option value="#002966"></option>
                  <option value="#3d1466"></option>
                </select>                    <span class="ql-format-separator"></span>
                <select class="ql-background">
                  <option selected="selected"></option>
                  <option value="#e60000"></option>
                  <option value="#ff9900"></option>
                  <option value="#ffff00"></option>
                  <option value="#008a00"></option>
                  <option value="#0066cc"></option>
                  <option value="#9933ff"></option>
                  <option value="#ffffff"></option>
                  <option value="#facccc"></option>
                  <option value="#ffebcc"></option>
                  <option value="#ffffcc"></option>
                  <option value="#cce8cc"></option>
                  <option value="#cce0f5"></option>
                  <option value="#ebd6ff"></option>
                  <option value="#bbbbbb"></option>
                  <option value="#f06666"></option>
                  <option value="#ffc266"></option>
                  <option value="#ffff66"></option>
                  <option value="#66b966"></option>
                  <option value="#66a3e0"></option>
                  <option value="#c285ff"></option>
                  <option value="#888888"></option>
                  <option value="#a10000"></option>
                  <option value="#b26b00"></option>
                  <option value="#b2b200"></option>
                  <option value="#006100"></option>
                  <option value="#0047b2"></option>
                  <option value="#6b24b2"></option>
                  <option value="#444444"></option>
                  <option value="#5c0000"></option>
                  <option value="#663d00"></option>
                  <option value="#666600"></option>
                  <option value="#003700"></option>
                  <option value="#002966"></option>
                  <option value="#3d1466"></option>
                </select>                    <span class="ql-format-separator"></span>
              </span>
              <span class="ql-formats">
                <button class="ql-list" value="ordered"></button>
                <button class="ql-list" value="bullet"></button>
                <select title="Text Alignment" class="ql-align">
                  <option selected>Left</option>
                  <option value="center" label="Center"></option>
                  <option value="right" label="Right"></option>
                  <option value="justify" label="Justify"></option>
                </select>
                <button class="ql-indent" value="-1"></button>
                <button class="ql-indent" value="+1"></button>
              </span>
              <span class="ql-formats">
                <button aria-label="Link" class="ql-link"></button>
                <!--button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;" #el
                      (click)="selectDocument(el)">D</button-->
                <button aria-label="Image" class="ql-image"></button>
                <button aria-label="Code block" class="ql-code-block"></button>
              </span>
              <span class="ql-formats">
                <button aria-label="Clean" class="ql-clean"></button>
              </span>
            </p-header>
          </p-editor>
        </div>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel expanded>
      <mat-expansion-panel-header>
        <mat-panel-title>Approach &amp; Estimate</mat-panel-title>
      </mat-expansion-panel-header>
      <div>
        <div style="display: flex; flex-direction: row;">
          <div style="flex:0 0 48%">
            <mat-form-field style="width: 100%">
              <mat-label>Approach</mat-label>
              <input matInput
                     [(ngModel)]="workstreamItem.approach">
            </mat-form-field>
          </div>
          <div style="flex:0 0 2%"></div>
          <div style="flex:0 0 48%">
            <mat-form-field style="width: 100%">
              <mat-label>Estimate</mat-label>
              <input matInput
                     [(ngModel)]="workstreamItem.estimate">
            </mat-form-field>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel expanded>
      <mat-expansion-panel-header>
        <mat-panel-title>Control Items</mat-panel-title>
      </mat-expansion-panel-header>
      <p-table [value]="controlItems">
        <ng-template pTemplate="header">
          <tr>
            <th>Control ID</th>
            <th>Framework</th>
            <th>Category</th>
            <th>Control Name</th>
            <th style="width: 3em;"></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
          <tr>
            <td>{{item.complianceAreaControlId}}</td>
            <td>{{item.complianceAreaName}}</td>
            <td>{{item.category}}</td>
            <td>{{item.name}}</td>
            <td>
              <button type="button"
                      pButton
                      class="risksponge-button"
                      (click)="removeControlItem(item)"
                      icon="pi pi-trash">
              </button>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <div>
        <button type="button"
                pButton
                class="risksponge-button"
                (click)="addControlItem()"
                icon="pi pi-plus">
        </button>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Elixir</mat-panel-title>
      </mat-expansion-panel-header>
      <div style="display: flex; flex-direction: row;">
        <div style="flex:0 0 100%">
          <mat-label style="color: rgba(0,0,0,.54)">Elixir Guidance</mat-label>
          <div [innerHTML]="workstreamItem.elixir"></div>
        </div>
      </div>
    </mat-expansion-panel>


    <mat-expansion-panel expanded>
    <mat-expansion-panel-header>
      <mat-panel-title>Documents</mat-panel-title>
    </mat-expansion-panel-header>
    <div>
      <span class="ql-editor"></span>
      <p-table *ngIf="workstreamItem.workstreamItemDocuments"
               [value]="workstreamItem.workstreamItemDocuments"
               #table>

        <ng-template pTemplate="header">
          <tr style="white-space: nowrap;font-weight: bold">
            <th *ngFor="let col of documentCols" [pSortableColumn]="col.field" [ngStyle]="{'width': col.width || 'auto'}">
              {{col.header}}
            </th>
            <th style="width:10em"></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
          <tr [pSelectableRow]="item">
            <td>
              {{item.date | date:'shortDate'}}
            </td>
            <td>
              <span style="font-size: 10.4px;" *ngIf="!item.name?.startsWith('http://') && !item.name?.startsWith('https://') && !item.name?.startsWith('\\\\') && !item.name?.startsWith('document://')" (click)="DownloadAttachment(item.name)" class="btn btn-link">{{item.name}}</span>
              <a style="font-size: 10.4px;" *ngIf="(item.name?.startsWith('http://') || item.name?.startsWith('https://') || item.name?.startsWith('\\\\')) && !item.name?.startsWith('document://')" [attr.href]="item.name" class="btn btn-link">{{item.name}}</a>
              <a style="font-size: 10.4px;" *ngIf="!item.name?.startsWith('http://') && !item.name?.startsWith('https://') && !item.name?.startsWith('\\\\') && item.name?.startsWith('document://')" (click)="DownloadAttachment(item.name.substring('document://'.length), true)" class="btn btn-link">{{item.fileName}}</a>

              <span *ngIf="item.editMode">
                <label for="{{'fileBlobAttachment' + rowIndex}}" class="btn">
                  <i class="pi pi-paperclip"></i>
                  <input id="{{'fileBlobAttachment' + rowIndex}}"
                         type="file"
                         [(ngModel)]="fileBlob1"
                         (change)="UploadAttachment($event, item)"
                         name="addAttachedFile1"
                         style="display: none;" />
                </label>
                <span (click)="addDocument(item)" style="font-weight: bold;">DL</span>
              </span>
            </td>
            <td>
              <span>{{getFullNameById(item.submitterId)}}</span>
            </td>
            <td>
              <span *ngIf="!item.editMode">{{item.notes}}</span>
              <span *ngIf="item.editMode">
                <mat-form-field style="width: 100%">
                  <input matInput [(ngModel)]="item.notes" />
                </mat-form-field>
              </span>
            </td>
            <td>
              <button *ngIf="!item.editMode"
                      type="button"
                      pButton
                      class="risksponge-button"
                      (click)="item.editMode = true; item.oldNotes = item.notes"
                      icon="pi pi-pencil">
              </button>
              <button *ngIf="item.editMode"
                      type="button"
                      pButton
                      class="risksponge-button"
                      (click)="item.editMode = false; saveAttachment(item)"
                      icon="pi pi-check">
              </button>
              <button *ngIf="item.editMode"
                      type="button"
                      pButton
                      class="risksponge-button"
                      (click)="item.editMode = false; item.notes = item.oldNotes;"
                      icon="pi pi-times">
              </button>
              <button type="button"
                      pButton
                      class="risksponge-button"
                      (click)="deleteAttachment(item)"
                      icon="pi pi-trash">
              </button>
            </td>
          </tr>

        </ng-template>

      </p-table>

      <div>
        <label class="btn" (click)="AddAttachment($event)">
          <i class="pi pi-plus"></i>
        </label>
      </div>
    </div>
    </mat-expansion-panel>
  </mat-accordion>

  <div mat-dialog-actions>
    <button mat-raised-button (click)="save()" style="border-radius: 6px;">Save</button>
    <button mat-raised-button style="border-radius: 6px;" (click)="close()">Cancel</button>
  </div>
</mat-dialog-content>
